var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tweet',{attrs:{"id":_vm.tweetId,"error-message":"This tweet could not be loaded","options":{ width: '100%' }}},[_c('div',{staticClass:"loading"},[_c('Loading',{attrs:{"isLoading":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }